import React from "react";

const Row = props => {
	const {children, style, className} = props;

	const stl = {...{display: 'flex', alignItems: 'center'}, ...style};

	return (
		<div style={stl} className={className}>
			{children}
		</div>
	)
};

export default Row;